import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import SmsIcon from "@mui/icons-material/Sms";
import { styled } from "styled-components";
import { useDispatch } from "react-redux";
import { alert } from "../../../redux/slices/alertSlice";
import { useAxios } from "../../../hooks";
import { Close } from "@mui/icons-material";
import { PrimaryButton } from "../../css components/Button";

// Styled components
const OTPTextField = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 16px;
  outline: none;
`;

const CircleIconBox = styled(Box)`
  width: 50px;
  height: 50px;
  background: #e5f7f4;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 10px;
`;

const ResendBtn = styled(PrimaryButton)`
  border: 2px solid #8f1c82;
  background: transparent;
  color: #8f1c82;
  &:hover {
    background: #f9e9f5;
  }
`;

const VerifyBtn = styled(PrimaryButton)`
  background: #28967e;
  color: white;
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

export default function VerifyOtpDialog({
  verifyOTP,
  setVerifyOTP,
  formikProps,
  brandID,
  agencyID,
}) {
  const dispatch = useDispatch();
  const axios = useAxios();

  const [loading, setLoading] = useState({ resend: false, verify: false });

  const handleClose = () => {
    formikProps.setValues({ ...formikProps.values, otp: "" });
    setVerifyOTP(false);
  };

  const resendOTP = () => {
    setLoading((prev) => ({ ...prev, resend: true }));
    axios({
      url: "/send/otp",
      method: "POST",
      disableRedirect: true,
      data: {
        mobile_number: formikProps.values.companyContact,
        msg_type: "registration",
        resend: true,
        ...(!!brandID && { brand_id: parseInt(brandID) }),
        ...(!!agencyID && { agency_id: parseInt(agencyID) }),
      },
    }).then((res) => {
      if (res.status) {
        dispatch(alert({ type: "success", message: "OTP sent successfully" }));
      }
      setLoading((prev) => ({ ...prev, resend: false }));
    });
  };

  const verifyOTPHandler = () => {
    setLoading((prev) => ({ ...prev, verify: true }));
    axios({
      url: "/verify/otp",
      method: "POST",
      disableRedirect: true,
      data: {
        mobile_number: formikProps.values.companyContact,
        msg_type: "registration",
        otp: formikProps.values.otp,
        ...(!!brandID && { brand_id: parseInt(brandID) }),
        ...(!!agencyID && { agency_id: parseInt(agencyID) }),
      },
    }).then((res) => {
      if (res.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          verifyNumber: true,
          otp: "",
        }));
        dispatch(
          alert({
            type: "success",
            message: "Phone Number Verified Successfully",
          })
        );
        setVerifyOTP(false);
      }
      setLoading((prev) => ({ ...prev, verify: false }));
    });
  };

  return (
    <Dialog
      open={verifyOTP}
      onClose={handleClose}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "16px",
            padding: "24px",
            minWidth: "420px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
          },
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Close />
      </IconButton>

      <DialogContent>
        <CircleIconBox>
          <SmsIcon sx={{ color: "#28967e", fontSize: 26 }} />
        </CircleIconBox>

        <Typography
          variant="h6"
          align="center"
          fontWeight={600}
          sx={{ color: "#28967e", mb: 8 }}
        >
          Verify OTP
        </Typography>

        <OTPTextField
          autoFocus
          maxLength={4}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          placeholder="Enter OTP"
          value={formikProps.values.otp}
          onChange={(e) => {
            if (!isNaN(e.target.value)) {
              formikProps.setFieldValue("otp", e.target.value);
            }
          }}
        />

        <Typography
          variant="body2"
          align="center"
          sx={{ mt: 1.5, color: "#555" }}
        >
          OTP sent to <strong>{formikProps.values.companyContact}</strong>
        </Typography>
      </DialogContent>

      <DialogActions>
        <ResendBtn disabled={loading.resend} onClick={resendOTP}>
          {loading.resend ? "Resending..." : "Resend OTP"}
        </ResendBtn>
        <VerifyBtn
          disabled={!formikProps.values.otp || loading.verify}
          onClick={verifyOTPHandler}
        >
          {loading.verify ? "Verifying..." : "Verify OTP"}
        </VerifyBtn>
      </DialogActions>
    </Dialog>
  );
}
